export const produto = `
query ($payload: ilastlimit) {
  Produto (payload: $payload) {
    id,
    code,
    tipo,
    name,
    link,
    status,
    preco,
    oferta,
    img {
      id,
      img
    },
    descricao,
    dateOfertaStart,
    dateOfertaEnd,
    categoria,
    gerEstoque,
    statusEstoque,
    estoque,
    exibeSemEstoque,
    pendencia,
    visibilidade,
    visualizacao,
    dateCreate,
    destaque,
    caracter {
      id,
      name,
      icon
    },
    atributos {
      active,
      id,
      name,
      values {
        active,
        id,
        name,
        selected
      }
    },
    estoqueVariavel {
      id,
      src {
        quantidade,
        values {
          id,
          idParent,
          name,
          value
        }
      }
    }
  }
}
`
export const SearchProduto = `
query ($payload: String) {
  SearchNameProd (payload: $payload) {
    id,
    code,
    tipo,
    name,
    link,
    status,
    preco,
    oferta,
    img {
      id,
      img
    },
    descricao,
    dateOfertaStart,
    dateOfertaEnd,
    categoria,
    gerEstoque,
    statusEstoque,
    estoque,
    exibeSemEstoque,
    pendencia,
    visibilidade,
    visualizacao,
    dateCreate,
    caracter {
      id,
      name,
      icon
    },
    atributos {
      active,
      id,
      name,
      values {
        active,
        id,
        name,
        selected
      }
    },
    estoqueVariavel {
      id,
      src {
        quantidade,
        values {
          id,
          idParent,
          name,
          value
        }
      }
    }
  }
}
`
export const suggestionproduto = `
query ($payload: icategorysuggestion) {
  GetSuggestion (payload: $payload) {
    id,
    code,
    tipo,
    name,
    link,
    status,
    preco,
    oferta,
    img {
      id,
      img
    },
    descricao,
    dateOfertaStart,
    dateOfertaEnd,
    categoria,
    gerEstoque,
    statusEstoque,
    estoque,
    exibeSemEstoque,
    pendencia,
    visibilidade,
    visualizacao,
    dateCreate,
    caracter {
      id,
      name,
      icon
    },
    atributos {
      active,
      id,
      name,
      values {
        active,
        id,
        name,
        selected
      }
    },
    estoqueVariavel {
      id,
      src {
        quantidade,
        values {
          id,
          idParent,
          name,
          value
        }
      }
    }
  }
}
`
export const filterprice = `
query ($payload: ifilterprice) {
  GetProducFilterPrice (payload: $payload) {
    id,
    code,
    tipo,
    name,
    link,
    status,
    preco,
    oferta,
    img {
      id,
      img
    },
    descricao,
    dateOfertaStart,
    dateOfertaEnd,
    categoria,
    gerEstoque,
    statusEstoque,
    estoque,
    exibeSemEstoque,
    pendencia,
    visibilidade,
    visualizacao,
    atributos {
      active,
      id,
      name,
      values {
        active,
        id,
        name,
        selected
      }
    },
    estoqueVariavel {
      id,
      src {
        quantidade,
        values {
          id,
          idParent,
          name,
          value
        }
      }
    },
    dateCreate,
    caracter {
      id,
      name,
      icon
    },
    qtda,
    destaque
  }
}
`
export const getproduct = `
query ($id: Int) {
  GetProduct (id: $id) {
    id,
    code,
    tipo,
    name,
    link,
    status,
    preco,
    oferta,
    img {
      id,
      img
    },
    descricao,
    dateOfertaStart,
    dateOfertaEnd,
    categoria,
    gerEstoque,
    statusEstoque,
    estoque,
    exibeSemEstoque,
    pendencia,
    visibilidade,
    visualizacao,
    atributos {
      active,
      id,
      name,
      values {
        active,
        id,
        name,
        selected
      }
    },
    estoqueVariavel {
      id,
      src {
        quantidade,
        values {
          id,
          idParent,
          name,
          value
        }
      }
    },
    dateCreate,
    caracter {
      id,
      name,
      icon
    },
    qtda,
    destaque
  }
}
`
export const produtcId = `
query ($payload: String) {
  GetProductId (id: $payload) {
    id,
    code,
    tipo,
    name,
    link,
    status,
    preco,
    oferta,
    img {
      id,
      img
    },
    descricao,
    dateOfertaStart,
    dateOfertaEnd,
    categoria,
    gerEstoque,
    statusEstoque,
    estoque,
    exibeSemEstoque,
    pendencia,
    visibilidade,
    visualizacao,
    dateCreate,
    caracter {
      id,
      name,
      icon
    },
    atributos {
      active,
      id,
      name,
      values {
        active,
        id,
        name,
        selected
      }
    },
    estoqueVariavel {
      id,
      src {
        quantidade,
        values {
          id,
          idParent,
          name,
          value
        }
      }
    }
  }
}
`
